module.exports = __webpack_public_path__ + "img/bonkers-logo-mark.cebb83d.svg";